<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-toc toc-with-volume-author" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents">
<div class="toc-bodymatter-group">
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Kristen Bickerstaff</p>
<p class="element-title"><a href="#/vol001"><span class="element-title-text">The Wish Shore</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Ken Hoover</p>
<p class="element-title"><a href="#/vol002"><span class="element-title-text">The Wreckers</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">L.V. Bell</p>
<p class="element-title"><span href="#/vol003" title="Link target outside of Sample"><span class="element-title-text">Scourge</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Tracy Leonard Nakatani</p>
<p class="element-title"><span href="#/vol004" title="Link target outside of Sample"><span class="element-title-text">The Pirate’s Cat</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">David Cole</p>
<p class="element-title"><span href="#/vol005" title="Link target outside of Sample"><span class="element-title-text">Annie Spark and the Pirates of Port 1337</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Linda Maye Adams</p>
<p class="element-title"><span href="#/vol006" title="Link target outside of Sample"><span class="element-title-text">Tidying Magic</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Trisha J. Wooldridge</p>
<p class="element-title"><span href="#/vol007" title="Link target outside of Sample"><span class="element-title-text">By Stars and by Gears</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Amy Hughes</p>
<p class="element-title"><span href="#/vol008" title="Link target outside of Sample"><span class="element-title-text">Porch Pirates of Pasadena</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Jessica Guernsey</p>
<p class="element-title"><span href="#/vol009" title="Link target outside of Sample"><span class="element-title-text">Sabbath</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Tanya Hales</p>
<p class="element-title"><span href="#/vol010" title="Link target outside of Sample"><span class="element-title-text">A Good Pirate’s Final Storm</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">John D. Payne</p>
<p class="element-title"><span href="#/vol011" title="Link target outside of Sample"><span class="element-title-text">Percival Bunnyrabbit and the Robot Wizard</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Lauren Lang</p>
<p class="element-title"><span href="#/vol012" title="Link target outside of Sample"><span class="element-title-text">Plundering Lives</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Melissa Koons</p>
<p class="element-title"><span href="#/vol013" title="Link target outside of Sample"><span class="element-title-text">Time Comes for All Men</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Elmdea Adams</p>
<p class="element-title"><span href="#/vol014" title="Link target outside of Sample"><span class="element-title-text">Life Pirate</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Jace Killan</p>
<p class="element-title"><span href="#/vol015" title="Link target outside of Sample"><span class="element-title-text">Pirated RPG</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Clint Hall</p>
<p class="element-title"><span href="#/vol016" title="Link target outside of Sample"><span class="element-title-text">Breath of the Cherubim</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Nancy DiMauro</p>
<p class="element-title"><span href="#/vol017" title="Link target outside of Sample"><span class="element-title-text">Princess Yum Yum’s Challenge</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">C.H. Hung</p>
<p class="element-title"><span href="#/vol018" title="Link target outside of Sample"><span class="element-title-text">Where We Will All Go</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Mary Pletsch</p>
<p class="element-title"><span href="#/vol019" title="Link target outside of Sample"><span class="element-title-text">Silver Future</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Julie Frost</p>
<p class="element-title"><span href="#/vol020" title="Link target outside of Sample"><span class="element-title-text">Sea Wolves</span></span></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Robert J. McCarter</p>
<p class="element-title"><span href="#/vol021" title="Link target outside of Sample"><span class="element-title-text">Harry the Ghost Pirate</span></span></p>
</div>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/abouttheeditor" title="Link target outside of Sample"><span class="element-title-text">About the Editor</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/ifyouliked" title="Link target outside of Sample"><span class="element-title-text">If You Liked …</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/otherwordfirepresstitleseditedbylisamangum" title="Link target outside of Sample"><span class="element-title-text">Other WordFire Press Titles Edited by Lisa Mangum</span></span></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?981617bc